import React, { useEffect, useRef, useState } from 'react';
import { Dialog } from '@mui/material';
import { useSignalR } from './SignalRContext/signalRContext';
import CallSound from '../assets/Sounds/TEKaVerse_Call.mp3';
import Test_Image from "../../src/assets/images/Authentek.jpg";
import '../../src/custom.css'

const GlobalCallNotification = ({ onOpen }) => {
    const audioRef = useRef(null);//handle audio for notification 
    const [timeoutId, setTimeoutId] = useState(null);
    const [isAudioLoaded, setIsAudioLoaded] = useState(false);
    const { incomingCallVisible, acceptCall, rejectCall, callerFullName, roomId, isMissed, setIsMissed } = useSignalR();



    useEffect(() => {
        if (incomingCallVisible && isAudioLoaded && audioRef.current) {
            const playPromise = audioRef.current.play();
            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    console.log("Audio play failed:", error);
                });
            }
            const timeout = setTimeout(() => {
                setIsMissed(true);
                if(isMissed){
                    rejectCall();
                }
            }, 30000);
            setTimeoutId(timeout);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
        };
    }, [incomingCallVisible, rejectCall, isAudioLoaded]);

    const stopAudio = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
    };

    const handleAcceptCall = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        stopAudio();
        acceptCall(); // Notify the caller
        onOpen(); // Open TwilioVideocall with room ID

    };

    const handleReject = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        stopAudio();
        rejectCall();
        onclose();
    };
    const handleAudioLoaded = () => {
        setIsAudioLoaded(true);
    };

    return (
        <Dialog open={incomingCallVisible}>
            <audio ref={audioRef} src={CallSound} loop onLoadedData={handleAudioLoaded} preload='auto' />
            <div className="incoming-call">
                <div className='avatar-incoming'>
                    <img src={Test_Image}></img>
                </div>
                <h4>Incoming Call...</h4>
                <h6>
                    Call From: <strong>{callerFullName?.trim().split(" ")[1] + " " + callerFullName?.trim().split(" ")[0]}</strong>
                </h6>
                <div className="call-btns">
                    <button onClick={handleReject} className="btn btn-bordered">Reject</button>
                    <button onClick={handleAcceptCall} className="btn btn-primary">Accept</button>
                </div>
            </div>
        </Dialog>
    );
}
export default GlobalCallNotification;